import React, { CSSProperties, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@src/utils';

import { useCookieContext } from '@components/CookiesNotification/context';
import Switch from '@components/Switch';

import ArrowIcon from './arrow.svg';
import { cookieOptions } from '../../helpers';

import style from './Cookie.scss';

const cn = bemCssModules(style, 'Cookie');

type CookieType = {
  cookie: (typeof cookieOptions)[number];
};

const Cookie: CustomFC<CookieType> = ({ className, cookie }) => {
  const { t } = useTranslation();
  const { setSelectedCookies, selectedCookies } = useCookieContext();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleOpen = () => {
    setIsOpen(prev => !prev);
  };

  const handleChange = () => {
    if (selectedCookies.includes(cookie.id)) {
      setSelectedCookies(prev => prev.filter(elem => elem !== cookie.id));
    } else {
      setSelectedCookies(prev => prev.concat(cookie.id));
    }
  };
  return (
    <div className={cn(null, [className])}>
      <div className={cn('header')} onClick={handleOpen}>
        <div className={cn('arrow')}>
          <ArrowIcon className={cn('icon', { active: isOpen })} />
        </div>
        <div className={cn('title')}>{t(cookie.title)}</div>
        <div className={cn('active')}>
          {cookie.isAllow ? (
            <div className={cn('permit')}>{t('cookies.cookie.always')}</div>
          ) : (
            <Switch
              className={cn('switch')}
              value={selectedCookies.includes(cookie.id)}
              onChange={handleChange}
            />
          )}
        </div>
      </div>
      <div
        className={cn('description-container', { show: isOpen })}
        style={{ '--height': ref.current?.offsetHeight + 'px' } as CSSProperties}
      >
        <div ref={ref} className={cn('description')}>
          {t(cookie.description)}
        </div>
      </div>
    </div>
  );
};

export default Cookie;
